module.exports = __webpack_public_path__ + "static/media/live.5b924abd.jpeg";